import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClientTableRow, TgClient } from '../../../models/telegram/tg-client.model';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.css']
})
export class ClientListComponent {

  @Input()
  clients: ClientTableRow[] | null = [];

  @Output()
  editClicked = new EventEmitter<any>();

  @Output()
  removeClicked = new EventEmitter<any>();  
}
